import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Faq.module.css';
import API_BASE_URL from '../../config/api';

const Faq = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const lang = language === 'ar' ? 'ar' : 'en';

    const fetchFaqs = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/faqs?lang=${lang}`, { signal: controller.signal });
        const data = await res.json();
        setFaqs(Array.isArray(data) ? data : data.data || []);
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Failed to load FAQs', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
    return () => controller.abort();
  }, [language]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.faqPage}>
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{t('faqPage.title')}</h1>
          <div className={styles.heroUnderline}></div>
          <p className={styles.heroSubtitle}>{t('faqPage.subtitle')}</p>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className={styles.container}>
          {loading ? (
            <div className={styles.loadingWrapper}>
              <div className={styles.spinner}></div>
            </div>
          ) : faqs.length === 0 ? (
            <p className={styles.emptyMessage}>{t('faqPage.noFaqs')}</p>
          ) : (
            <div className={styles.accordionList}>
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={faq.id || index}
                    className={`${styles.accordionItem} ${isOpen ? styles.accordionItemOpen : ''}`}
                  >
                    <button
                      className={styles.accordionHeader}
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                    >
                      <span className={styles.questionText}>{faq.question}</span>
                      <span className={`${styles.accordionIcon} ${isOpen ? styles.accordionIconOpen : ''}`}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </span>
                    </button>
                    <div className={`${styles.accordionBody} ${isOpen ? styles.accordionBodyOpen : ''}`}>
                      <div className={styles.answerText}>{faq.answer}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Faq;
